import React from 'react';
import Serializer, {
  type SerializeArguments,
  type DeserializeArguments,
} from './Serializer';
import { type TranscriptSpeakerElement } from '../../types/aha-editor';
import { type Descendant } from 'slate';
import { isHTMLElementNode } from '../helpers/serializerHelpers';
import { isTranscriptSpeakerElement } from '../../types/guards';

class SerializerTranscriptSpeaker extends Serializer {
  static deserialize({
    el,
    next,
    markAttributes,
  }: DeserializeArguments):
    | TranscriptSpeakerElement
    | Descendant[]
    | undefined {
    if (
      !isHTMLElementNode(el) ||
      el.tagName.toLowerCase() !== 'p' ||
      el.getAttribute('data-aha-editor-type') !== 'transcript-speaker'
    )
      return;

    return {
      type: 'transcript-speaker',
      speaker_name: el.getAttribute('data-transcript-speaker-name') || '',
      children: next(el.childNodes, markAttributes),
    };
  }

  static serialize({ node, children }: SerializeArguments): React.ReactNode {
    if (!isTranscriptSpeakerElement(node)) return;

    const { speaker_name } = node;

    return (
      <p
        data-aha-editor-type="transcript-speaker"
        data-transcript-speaker-name={speaker_name}
      >
        {children}
      </p>
    );
  }
}

export default SerializerTranscriptSpeaker;
